import React from 'react';

/**
 * The table on a printed receipt, so whoever carries the food reads it from the ticket: centred,
 * 64 px extra-bold in a 4 px box, upper case. Sizes are printer dots (the receipt is captured at
 * scale 1), the same on 58 mm (384 dots) and 80 mm (576 dots) paper. Long names wrap.
 *
 * Shared by the direct-restaurant receipt and the partner receipt (PROD-778).
 */
export default function ReceiptTableBox({ label }) {
  if (!label) {
    return null;
  }

  return (
    <p
      data-testid="receipt-table-box"
      className="mt-4 mb-0 border-4 border-black px-3 py-2 text-center text-black font-extrabold uppercase text-[64px] leading-[72px] break-words [overflow-wrap:anywhere]"
    >
      {label}
    </p>
  );
}
